import React, { useEffect, useRef } from 'react';
import GLOBAL from '../../../global';
import { useTenantFeatures } from '../../../features/tenantFeatures/useTenantFeature';

const UserMediaWebcam = ({ videoConstraints, onUserMedia, onUserMediaError, webcamRef, onPlay, mirrored }) => {
    const streamRef = useRef(null);

    const { videoFrameRate, videoResolutionWidth, videoResolutionHeight } = useTenantFeatures();
    const maxVideoFrameRate = Number(videoFrameRate) || 30;
    const maxVideoResolutionWidth = Number(videoResolutionWidth) || 1280;
    const maxVideoResolutionHeight = Number(videoResolutionHeight) || 720;

    useEffect(() => {
        getMedia();

        return () => {
            if (streamRef.current) {
                const tracks = streamRef.current.getTracks();
                tracks.forEach(track => {
                    track.stop();
                });
                if (webcamRef.current) {
                    webcamRef.current.srcObject = null;
                }
            }
        };
    }, [videoConstraints?.deviceId, onUserMedia, onUserMediaError]);

    async function getMedia() {
        try {
            const constraints = {
                ...videoConstraints,
            };
            if (constraints.width && !constraints.width.max && !constraints.width.ideal) {
                constraints.width = { ideal: Math.min(constraints.width, maxVideoResolutionWidth) };
            } else if (typeof constraints.width === 'number') {
                constraints.width = { ideal: Math.min(constraints.width, maxVideoResolutionWidth) };
            }
            if (constraints.height && !constraints.height.max && !constraints.height.ideal) {
                constraints.height = { ideal: Math.min(constraints.height, maxVideoResolutionHeight) };
            } else if (typeof constraints.height === 'number') {
                constraints.height = { ideal: Math.min(constraints.height, maxVideoResolutionHeight) };
            }
            if (!constraints.frameRate) {
                constraints.frameRate = { ideal: maxVideoFrameRate, max: maxVideoFrameRate };
            } else if (typeof constraints.frameRate === 'number') {
                constraints.frameRate = { ideal: Math.min(constraints.frameRate, maxVideoFrameRate), max: maxVideoFrameRate };
            }

            streamRef.current = await navigator.mediaDevices.getUserMedia({
                video: constraints,
            });

            const videoTrack = streamRef.current.getVideoTracks()[0];
            if (videoTrack) {
                await videoTrack.applyConstraints({
                    width: { max: maxVideoResolutionWidth },
                    height: { max: maxVideoResolutionHeight },
                    frameRate: { max: maxVideoFrameRate },
                });
            }

            if (webcamRef.current) {
                webcamRef.current.srcObject = streamRef.current;
                onUserMedia();
            }
        } catch (e) {
            onUserMediaError(e);
        }
    }

    return (
        <video
            ref={webcamRef}
            style={{
                height: '100%',
                width: '100%',
                objectFit: 'fill',
                position: 'absolute',
                transform: mirrored ? 'scaleX(-1)' : 'none',
            }}
            autoPlay
            playsInline
            muted
            disablePictureInPicture
            // onPlay={onPlay}
        />
    );
};

export default UserMediaWebcam;
